import { API_REQUEST, ENOTIFICATION_SUBMIT } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export interface EnotifPayload extends Record<string, unknown> {
    firstname: string;
    lastname: string;
    phone: string;
    email: string;
    entries: EnotifPendingChange[],
    user_profile_id: string
}

export interface EnotifPendingChange {
    roll: string;
    enotif_enabled: boolean;
    address: string
}

export const updateEnotifs = (payload: EnotifPayload ): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/enotifications/update`,
        next: ENOTIFICATION_SUBMIT,
        method: 'PUT',
        authorization: true,
        data: payload
    }
});